import { render, staticRenderFns } from "./df-loading-mask.vue?vue&type=template&id=0aa1b796"
import script from "./df-loading-mask.ts?vue&type=script&lang=js&external"
export * from "./df-loading-mask.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports